/**
 * Redirect trailing slashes to non-trailing slash. Somehow, the Vue/Nuxt router
 * allows this, and these pages were causing an SEO problem. They now need to be
 * redirected to correct it.
 */
export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path !== '/' && to.path.endsWith('/')) {
    const path = to.path.slice(0, -1)
    const query = Object.keys(to.query).length ? to.query : undefined

    return navigateTo(
      {
        path,
        query,
      },
      { redirectCode: 301 }
    )
  }
})
